import { Locale } from '../../Entities/Locale/Locale.entity';
import { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const canShowReserve = (locale: Locale, vehicle: Vehicle, reserveNowFlag: boolean) =>
  reserveNowFlag &&
  locale === 'uk' &&
  !vehicle.ecom.isEcom &&
  vehicle.details.status === 'active' &&
  vehicle?.pricing?.package?.reservation === true;
